/* tslint:disable */
/* eslint-disable */
/**
 * Main data new API
 * Auto-generated openapi scheme for main-data-new API
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ReadOnlyOBUNested,
    ReadOnlyOBUNestedFromJSON,
    ReadOnlyOBUNestedFromJSONTyped,
    ReadOnlyOBUNestedToJSON,
} from './';

/**
 * 
 * @export
 * @interface InlineResponse20038
 */
export interface InlineResponse20038 {
    /**
     * 
     * @type {number}
     * @memberof InlineResponse20038
     */
    count: number;
    /**
     * 
     * @type {string}
     * @memberof InlineResponse20038
     */
    next?: string | null;
    /**
     * 
     * @type {string}
     * @memberof InlineResponse20038
     */
    previous?: string | null;
    /**
     * 
     * @type {Array<ReadOnlyOBUNested>}
     * @memberof InlineResponse20038
     */
    results: Array<ReadOnlyOBUNested>;
}

export function InlineResponse20038FromJSON(json: any): InlineResponse20038 {
    return InlineResponse20038FromJSONTyped(json, false);
}

export function InlineResponse20038FromJSONTyped(json: any, ignoreDiscriminator: boolean): InlineResponse20038 {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'count': json['count'],
        'next': !exists(json, 'next') ? undefined : json['next'],
        'previous': !exists(json, 'previous') ? undefined : json['previous'],
        'results': ((json['results'] as Array<any>).map(ReadOnlyOBUNestedFromJSON)),
    };
}

export function InlineResponse20038ToJSON(value?: InlineResponse20038 | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'count': value.count,
        'next': value.next,
        'previous': value.previous,
        'results': ((value.results as Array<any>).map(ReadOnlyOBUNestedToJSON)),
    };
}


